import './index.css'

import React from 'react'
import { connect } from 'react-redux'

import { getConstanceSettings } from '@disco/state-management/selectors/user'

import EllipsisMenu from 'components/ui/ellipsis-menu'

import EditWriter from '../edit-writer'

const mapStateToProps = state => {
  return {
    constanceSettings: getConstanceSettings(state),
  }
}

type Props = {
  editMode: boolean
  trackId: number
  split: Record<string, any>
  serverError: string | null | undefined
  onEdit: (...args: Array<any>) => any
  onDelete: (...args: Array<any>) => any
  onUpdate: (...args: Array<any>) => any
  editExclusionList: number[]
  disableEditing: boolean
  getWriters?: (...args: Array<any>) => any
  saveAction?: boolean
  inlineValidations?: boolean
  editingKey: number
  onUnsavedChanges: (...args: Array<any>) => any
  listOfWritersToCreate: Record<string, any>[]
  defaultWriters: Record<string, any>[]
  trackWriterIds?: Array<number>
  updateWriterIds: (arg0: Array<number>) => void
  constanceSettings: Record<string, any>
}

const TrackWriter = ({
  editMode,
  trackId,
  split,
  onEdit,
  onDelete,
  onUpdate,
  editExclusionList,
  serverError,
  disableEditing,
  getWriters,
  saveAction,
  inlineValidations,
  editingKey,
  onUnsavedChanges,
  listOfWritersToCreate,
  defaultWriters,
  constanceSettings,
}: Props): React.ReactNode | React.ReactElement<'div'> => {
  const name = split.writer.name || split.writer.email

  if (!disableEditing && editMode) {
    const commonProps = {
      track: trackId,
      split: split,
      exclusionList: editExclusionList,
      type: 'edit' as const,
      serverError: serverError,
      onSubmit: onUpdate,
      onCancel: onEdit,
      getWriters: getWriters,
      saveAction: saveAction,
      inlineValidations: inlineValidations,
      editingKey: editingKey,
      onUnsavedChanges: onUnsavedChanges,
      listOfWritersToCreate: listOfWritersToCreate,
      defaultWriters: defaultWriters,
    }

    return <EditWriter {...commonProps} />
  }

  return (
    <div className="track-writers__item flc">
      <div className="track-writers__item__writer" title={name}>
        {name}
      </div>
      <div className="track-writers__item__split">
        {split.split ? `${split.split}%` : '-'}
      </div>
      <div className="track-writers__item__publisher">
        {split.publisher ? split.publisher.name : '-'}
      </div>
      <div className="track-writers__item__pro">
        {split.pro ? split.pro.name : '-'}
      </div>
      <div className="track-writers__item__actions">
        {!disableEditing && (
          <EllipsisMenu
            compact
            hasArrow={false}
            icon="ellipsis-vertical"
            options={[
              {
                value: 'split_edit',
                label: 'Edit',
              },
              {
                value: 'split_delete',
                label: 'Delete',
              },
            ]}
            onOptionClick={option => {
              switch (option) {
                case 'split_edit':
                  onEdit(split.id)
                  break

                case 'split_delete':
                  onDelete(trackId, split.id)
                  break
              }
            }}
          />
        )}
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(TrackWriter) as any
